/* eslint-disable @typescript-eslint/no-explicit-any */
// TODO: This file was automatically migrated to TypeScript by `dev typescript migrate`.
//  The eslint disable comment above should be removed and the resulting errors fixed.
import React from 'react';

import Modal from 'ui-library/modals/Modal';

// @ts-expect-error
import CRISPRAnalysisActions from './CRISPRAnalysisActions';
import SetDefaultsInput from './SetDefaultsInput';
// @ts-expect-error
import SettingsForm from './SettingsForm';

interface Props {
  allowEdits: boolean;
  analysis: any;
  analysisLoading: boolean;
  onRequestClose: (...args: Array<any>) => any;
  findGuidesParams: any;
}

type State = any;

class SettingsModal extends React.Component<Props, State> {
  state: State = {
    submitted: false,
    formValidated: true,
  };

  settingsFormRef = React.createRef<SettingsForm>();
  setDefaultsInputRef = React.createRef<SetDefaultsInput>();

  UNSAFE_componentWillReceiveProps(nextProps: Props): void {
    if (this.isSaving() && !nextProps.analysisLoading) {
      this.props.onRequestClose();
    }
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  setValid = (valid: any) => {
    this.setState({formValidated: valid});
  };

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  isSaving = () => this.state.submitted && this.props.analysisLoading;

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  save = () => {
    const settings = this.settingsFormRef.current.getChangedAnalysisSettings();
    // If the user submits the form without changing anything, still want to be able to set as defaults.
    this.setDefaultsInputRef.current!.setDefaults(this.settingsFormRef.current.getAllSettings());
    CRISPRAnalysisActions.update(this.props.analysis.id, settings, this.props.findGuidesParams);
    this.setState({submitted: true});
  };

  render(): JSX.Element {
    return (
      <Modal
        title={`CRISPR analysis settings${this.props.allowEdits ? '' : ' (read-only)'}`}
        onRequestSubmit={this.save}
        onRequestClose={this.props.onRequestClose}
        buttons={[
          {
            text: this.isSaving() ? 'Saving...' : 'Save',
            submit: true,
            disabled: this.isSaving() || !this.state.formValidated || !this.props.allowEdits,
          },
        ]}
        footer={React.createElement(SetDefaultsInput, {
          disabled: !this.props.allowEdits,
          initialShouldSetDefaults: false,
          ref: this.setDefaultsInputRef,
        })}
        dataTestAttrs={{component: 'SettingModal', element: 'modal'}}
      >
        <SettingsForm
          allowEdits={this.props.allowEdits}
          analysis={this.props.analysis}
          setValid={this.setValid}
          ref={this.settingsFormRef}
        />
      </Modal>
    );
  }
}

export default SettingsModal;
